"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridList = require("../GridList");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClippingList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var clippings = _ref.clippings,
      cols = _ref.cols,
      onClickItem = _ref.onClickItem,
      title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_GridList.ImageList, {
    tileData: clippings,
    cols: cols,
    onClickItem: onClickItem,
    title: title,
    subtitle: subtitle
  }));
});

var _default = ClippingList;
exports["default"] = _default;
ClippingList.defaultProps = {
  clippings: [],
  cols: 2,
  onClickItem: function onClickItem(e) {
    console.log(e);
  },
  title: null,
  subtitle: null
};
ClippingList.propTypes = {
  clippings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    image: _propTypes["default"].string
  })).isRequired,
  cols: _propTypes["default"].number,
  onClickItem: _propTypes["default"].func
};